/**
 * Role Service Layer - 业务逻辑层 + Mock 适配
 */

import { config } from '../../config';
import * as roleMock from '../../mocks/role';
import type { ApiResponse, PageData } from '../../types/common';
import type {
  Role,
  PageRoleRequest,
  PageRoleData,
  CreateRoleRequest,
  UpdateRoleRequest,
  UpdateMenuPermissionsRequest,
} from '../../types/role/index';
import httpClient from '../httpClient';
import { API_ENDPOINTS } from '../../utils/apiEndpoints';

/**
 * 分页查询角色 (符合 domain-frontend-spec 规范)
 */
export async function pageRoles(
  params: PageRoleRequest
): Promise<ApiResponse<PageRoleData>> {
  if (config.mock) {
    return roleMock.mockPageRoles(params);
  }

  return httpClient.post(API_ENDPOINTS.ROLE.PAGE, params);
}

/**
 * 创建角色
 */
export async function createRole(data: CreateRoleRequest): Promise<ApiResponse<Role>> {
  if (config.mock) {
    return roleMock.mockCreateRole(data);
  }

  return httpClient.post(API_ENDPOINTS.ROLE.CREATE, data);
}

/**
 * 更新角色
 */
export async function updateRole(data: UpdateRoleRequest): Promise<ApiResponse<Role>> {
  if (config.mock) {
    return roleMock.mockUpdateRole(data);
  }

  return httpClient.post(API_ENDPOINTS.ROLE.UPDATE, data);
}

/**
 * 删除角色
 */
export async function deleteRole(code: string): Promise<ApiResponse<void>> {
  if (config.mock) {
    return roleMock.mockDeleteRole(code);
  }

  return httpClient.post(API_ENDPOINTS.ROLE.DELETE, { code });
}

/**
 * 更新角色的菜单权限（新增授权）
 */
export async function updateMenuPermissions(
  data: UpdateMenuPermissionsRequest
): Promise<ApiResponse<void>> {
  if (config.mock) {
    return roleMock.mockUpdateMenuPermissions(data);
  }

  return httpClient.post(API_ENDPOINTS.ROLE.UPDATE_MENU_PERMISSIONS, data);
}

/**
 * 移除角色的菜单权限（取消授权）
 */
export async function removeMenuPermissions(
  data: UpdateMenuPermissionsRequest
): Promise<ApiResponse<void>> {
  if (config.mock) {
    return roleMock.mockUpdateMenuPermissions(data);
  }

  return httpClient.post(API_ENDPOINTS.ROLE.REMOVE_MENU_PERMISSIONS, data);
}

/**
 * 查询角色已授权的菜单权限
 */
export async function queryAuthedPermissions(
  roleCode: string,
  appDomain: string
): Promise<ApiResponse<any>> {
  if (config.mock) {
    return roleMock.mockQueryAuthedPermissions(roleCode);
  }

  return httpClient.post(API_ENDPOINTS.ROLE.QUERY_AUTHED_PERMISSIONS, {
    authedRole: roleCode,
    appDomain,
    currentPage: 1,
    pageSize: 100,
  });
}
